import type { GridFieldType } from '@/features/Inventory/ObjectTypePassportGrid/model/types'
import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'

export const LIST_CATALOG_NAME_GRID_PREFIX = 'list-catalog-name:'

export function listCatalogNameGridId(linkedInventTypeId: number): string {
  return `${LIST_CATALOG_NAME_GRID_PREFIX}${Number(linkedInventTypeId)}`
}

export function isListCatalogNameGridId(gridId: string): boolean {
  return String(gridId).startsWith(LIST_CATALOG_NAME_GRID_PREFIX)
}

export function parseListCatalogNameTypeId(gridId: string): number | null {
  const s = String(gridId)
  if (!s.startsWith(LIST_CATALOG_NAME_GRID_PREFIX)) return null
  const n = Number(s.slice(LIST_CATALOG_NAME_GRID_PREFIX.length))
  return Number.isFinite(n) && n > 0 ? n : null
}

/** Sidebar chip + runtime cell: read-only label for the linked inventory type (`objectTypeId` on a `list_types` branch). */
export function syntheticListCatalogNameInventoryField(
  linkedInventTypeId: number,
  paletteLabel: string,
): ObjectInventoryField {
  const tid = Number(linkedInventTypeId)
  return {
    id: listCatalogNameGridId(tid),
    name: paletteLabel.trim() || 'Наименование типа',
    type: 'string',
    items: [],
    default_value: '',
    object_type: tid,
    multiple: false,
    count_object: false,
    is_filtered: false,
    is_table: false,
    is_system: true,
    is_global_search: false,
  }
}

export function collectListCatalogNameTypeIdsFromTemplate(
  template: GridFieldType[] | null | undefined,
): number[] {
  if (!Array.isArray(template)) return []
  const out = new Set<number>()
  for (const item of template) {
    if (!item || typeof item !== 'object') continue
    const tid = parseListCatalogNameTypeId(String((item as GridFieldType).id ?? ''))
    if (tid != null) out.add(tid)
  }
  return [...out]
}
